import {useState} from 'react'
import type {Profile} from 'src/common/helpers/config'
import {configs, getProfile} from 'src/common/helpers/config'

export const useGetConfig = () => {
  const [profile] = useState<Profile>(() => {
    if (typeof window !== 'undefined') {
      return getProfile()
    }

    return 'dev'
  })

  return configs[profile]
}
